import { facadeApi } from 'api'
import { FileItem, UploadFileDataDTO, UploadFileInfo } from 'types/files/files'

interface GenerateFileUploadUrlApiResponse {
  uploadInfo: UploadFileInfo
  fileInfo: FileItem
}

export const generateFileUploadUrlApi = (uploadFileData: UploadFileDataDTO) =>
  facadeApi.post<GenerateFileUploadUrlApiResponse>('file-manager/v1/files/generate-upload-url', uploadFileData)
